export default {"src":"/_next/static/media/tv.d972eaa1.svg","height":100,"width":100};